import PieChart from '../components/pie/pie.vue';
import BarChart from '../components/bar/bar.vue';
import MapChart from '../components/map/map.vue';
import LineChart from '../components/line/line.vue';
import mapData from './mapData.js';

const arr1 = [
  { value: 522.5, name: '2010年' },
  { value: 343.6, name: '2013年' },
  { value: 357.9, name: '2014年' },
  { value: 368.5, name: '2015年' },
];
const arr2 = [
  { value: 717, name: '2010年' },
  { value: 581, name: '2013年' },
  { value: 598, name: '2014年' },
  { value: 649, name: '2015年' },
];
const arr3 = [
  { value: 2.1, name: '2010年' },
  { value: 30, name: '2013年' },
  { value: 27.4, name: '2014年' },
  { value: 75.6, name: '2015年' },
];
const arr4 = [
  { value: 5, name: '2010年' },
  { value: 63, name: '2013年' },
  { value: 45, name: '2014年' },
  { value: 110.9, name: '2015年' },
];
const arr5 = [
  { value: 156, name: '2010年' },
  { value: 257.3, name: '2013年' },
  { value: 230.4, name: '2014年' },
  { value: 171.2, name: '2015年' },
];
const arr6 = [
  { value: 1269, name: '2010年' },
  { value: 3937.7, name: '2013年' },
  { value: 2948.4, name: '2014年' },
  { value: 1919.4, name: '2015年' },
];
const arr7 = [
  { value: 60.4, name: '2010年' },
  { value: 257.3, name: '2013年' },
  { value: 208.7, name: '2014年' },
  { value: 169.4, name: '2015年' },
];
const arr8 = [
  { value: 33, name: '2010年' },
  { value: 160, name: '2013年' },
  { value: 142.8, name: '2014年' },
  { value: 128.5, name: '2015年' },
];
export default {
  name: 'cdyZbIndex',
  components: {
    PieChart,
    BarChart,
    MapChart,
    LineChart,
  },

  data() {
    return {
      todayPrice: [],
      manuId: '210321070810050001',
      transactionInfo: {},
      entranceInfo: {},
      progress: true,
      flag: true,
      flag1: true,
      flag2: true,
      flag3: true,
      flag4: true,
      flag5: true,
      flag6: true,
      mapData,
      mapShow: false,
      swiperlist: [],
      swiperlist2: [],
      swiperlist3: [],
      swiperlist4: [], // 草料价格公告版
      times: '',
      imgarr: [
        {
          url: 'https://nfs.nxin.com/cms_image_859135d1-3a71-41c6-b49a-dd707a4a4cb9.png',
          show: true,
          type: 'YQ',
          name: '园区分布'
        },
        {
          url: 'https://nfs.nxin.com/cms_image_cac7a52c-c18c-49ab-9f27-2a00002863d3.png',
          show: true,
          type: 'C',
          name: '草数据'
        },
        {
          url: 'https://nfs.nxin.com/cms_image_edd6ff90-7722-4235-84b8-adbeaa48d5c8.png',
          show: true,
          type: 'N',
          name: '牛数据'
        },
        {
          url: 'https://nfs.nxin.com/cms_image_70c271ea-bedb-4be1-a334-a093e29bd814.png',
          show: true,
          type: 'M',
          name: '马数据'
        },
        {
          url: 'https://nfs.nxin.com/cms_image_4dd293cc-f816-4f5e-b497-7c4ba924bec8.png',
          show: true,
          type: 'Y',
          name: '羊数据'
        }
      ],
      leftPanel1tabs: [{ name: '燕麦' }, { name: '苜蓿' }, { name: '羊草' }, { name: '青贮玉米' }],
      leftPanel1active: 0,
      leftPanel2active: 0,
      leftPanel2active1: true,
      leftPanel2active2: true,
      leftPanel3active1: true,
      leftPanel3active2: true,
      leftPanel4active1: true,
      leftPanel4active2: true,
      rightPanel2active1: true,
      rightPanel2active2: true,
      rightPanel2active3: true,
      rightPanel2active4: true,
      rightPanel2active5: true,
      leftPanel1: {
        data: arr1,
        unit: '万吨',
        color: ['#33a7ff', '#5c17e5', '#b800ff', '#ff66e5'],
        title: '产量'
      },
      leftPanel1s: {
        data: arr2,
        unit: '万亩',
        color: ['#33a7ff', '#5c17e5', '#b800ff', '#ff66e5'],
        title: '面积'
      },
      leftPanel2tabs: [{ name: '全国' }, { name: '内蒙' }],
      leftPanel2: {
        data: [],
        unit: '头',
        radius: ['47%', '80%']
      },
      leftPanel3: {
        series: [
          {
            name: '全国',
            value: [4264.95, 4340.26, 4397.48, 4533.87, 4565.45],
            show: true,
            colors: 0
          },
          {
            name: '内蒙',
            value: [339.75, 363.19, 375.1, 333.34, 346.76],
            show: true,
            colors: 1
          }
        ],
        category: ['2016年', '2017年', '2018年', '2019年', '2020年']
      },
      leftPanel4: {
        series: [
          {
            name: '全国',
            value: [63974250, 65103900, 65962200, 68008050, 68481750],
            colors: 0,
            show: true
          },
          {
            name: '内蒙',
            value: [5096250, 5447850, 5626500, 5000034.6, 5201360.55],
            colors: 1,
            show: true
          }
        ],
        category: ['2016年', '2017年', '2018年', '2019年', '2020年']
      },
      rightPanel2tabs: [
        {
          name: '前天',
          code: -2
        },
        {
          name: '昨天',
          code: -1
        },
        {
          name: '今天',
          code: 0
        }
      ],
      rightPanel2: {
        series: [],
        category: []
      },
      rightPanel3: {
        series: [
          {
            name: '平台覆盖牛源量趋势',
            value: [32300, 25600, 72100, 75800, 78000, 51000, 26000],
            colors: 0,
            show: true
          }
        ],
        category: [
          ['01月', '2021年'],
          ['02月', '2021年'],
          ['03月', '2021年'],
          ['04月', '2021年'],
          ['05月', '2021年'],
          ['06月', '2021年'],
          ['07月', '2021年']
        ]
      },
      rightPanel1: [
        {
          name: '牛交易',
          width: 10,
          text: '123万'
        },
        {
          name: '马交易',
          width: 10,
          text: '123万'
        },
        {
          name: '驴交易',
          width: 10,
          text: '123万'
        },
        {
          name: '骡交易',
          width: 10,
          text: '123万'
        },
        {
          name: '骆驼交易',
          width: 10,
          text: '123万'
        }
      ],
      rightPanel2Index: 2,
      business1: 5101476.19,
      business2: 2542558,
      business3: 1110356.93,
      business4: 1046029.29,
      business5: 1046029.29,
      businesszong: 5101476.19 + 2542558 + 1110356.93 + 1046029.29 + 1046029.29
    };
  },
  created() {
    this.datalist();
    var day2 = new Date();
    day2.setTime(day2.getTime());
    var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate();
    this.times = s2;
  },
  mounted() {
    this.selTodayPriceOffer();
    this.selShopListBySortDesc();
    this.selShopTageRankingByParam();
    this.selVehicleListByParam();
    this.selPaidMoneyGroupByCategory();
    this.selTradingBulletinBoard();
    this.countNumGroupByCate();
    this.selTradingData();
    this.countNumByType();
    this.selBigdataPriceOfferByForm(this.rightPanel2tabs[this.rightPanel2Index]);
    this.selPriceOfferByListByPage();
    // for (let i = 0; i < 30; i++) {
    //   this.swiperlist4.push({
    //     timeStr: '2022-03-04',
    //     address: '张家口',
    //     name: '大麦草',
    //     price: '3333元/吨',
    //   });
    // }
  },
  methods: {
    /**
 * @tip 获取【-2前天 -1昨天，0今天，1明天】
 * @num -1昨天 0今天 1明天
 * @return yyyy-mm-dd
*/
    submitTimejt(num) {
      let timerValue = '';
      const value = this.getDate(num);
      timerValue = value;
      return timerValue;
    },
    getDate(dates) {
      const dd = new Date();
      const n = dates;
      dd.setDate(dd.getDate() + n);
      const y = dd.getFullYear();
      let m = dd.getMonth() + 1;
      let d = dd.getDate();
      m = m < 10 ? `0${m}` : m;
      d = d < 10 ? `0${d}` : d;
      const day = `${y}-${m}-${d}`;
      return day;
    },
    selPriceOfferByListByPage() {
      this.$store.dispatch('zbData/selPriceOfferByListByPage', {
        categoryAxisLike: '$11006',
        areaAxisLike: '$44$2833$2840',
        boId: '',
        dailyPersonLike: '',
        isEnabled: 1,
        pageNum: 1,
        pageSize: 20,
      }).then((res) => {
        console.log('res==', res.list);
        if (res && res.list) {
          this.swiperlist4 = res.list.map((item) => {
            return {
              name: item.categoryName,
              address: item.areaFullName.substring(item.areaFullName.lastIndexOf('/') + 1),
              price: `${item.avgPrice}元/吨`,
              timeStr: item.offerDateStr.substring(0, 10),
            };
          });
        }
      });
    },
    selTodayPriceOffer() {
      this.$store
        .dispatch('zbData/selTodayPriceOffer', {
          areaId: '2840',
        })
        .then((res) => {
          console.log('selShopListBySortDesc==', res);
          if (res) {
            this.todayPrice = res.map((item) => {
              return `${item.smallPrice}~${item.bigPrice}元/斤`;
            });
          }
        });
    },
    rightPanel2Click(index) {
      this.rightPanel2Index=index;
      this.selBigdataPriceOfferByForm(this.rightPanel2tabs[index]);
    },
    selBigdataPriceOfferByForm(item) {
      this.$store
        .dispatch('zbData/selAvgPriceByManuId', {
          categoryIdList: ['110101', '110102', '110103', '110104', '110105', '110106', '110107', '110108', '110109', '110110', '110111'],
          // areaId: '2840',
          // channel: 'BJHZ',
          // queryDaysType: '30',
          paymentTimeStart: `${this.submitTimejt(item.code)} 00:00:00`,
          paymentTimeEnd: `${this.submitTimejt(item.code)} 23:59:59`,
          manuId: this.manuId,
        })
        .then((res) => {
          console.log('selBigdataPriceOfferByForm==', res);
          if (res) {
            const colorsTemp = [
              '#F59A23',
              '#EC808D',
              '#63A103',
              '#8080FF',
              '#0000FF',
              '#81D3F8',
              '#AAAA00',
              '#016FA0',
              '#910012',
              '#00AAAA',
              '#C280FF',
            ];
            const category = res.map((item) => {
              return item.categoryName
            });
            const value = res.map((item, index) => {
              return {
                value: item.avgPrice,
                itemStyle: {
                  color: colorsTemp[index]
                },
              };
            });
            this.rightPanel2 = {
              series: [
                {
                  name: '平均价格',
                  unit: '元/头',
                  show: true,
                  colors: 0,
                  value
                }
              ],
              category
            };
            this.flag6 = !this.flag6;
          } else {
            this.rightPanel2 = {
              category: ['牛', '马', '羊', '骆驼'],
              series: [
                {
                  name: '平均价格',
                  unit: '元',
                  show: true,
                  colors: 0,
                  value: [6418.45, 6119.06, 5707.54, 4843]
                }
              ]
            };
            console.log('selBigdataPriceOfferByForm==', this.rightPanel2);
            this.flag6 = !this.flag6;
          }
        });
    },
    selExistingCaregoNumByRelBoId() {
      this.$store
        .dispatch('zbData/selExistingCaregoNumByRelBoId', {
          typeList: ['CC', 'RC'],
          manuId: this.manuId,
        })
        .then((res) => {
          console.log('selShopListBySortDesc==', res);
        });
    },
    // 地图交易流向
    selVehicleListByParam() {
      this.$store
        .dispatch('zbData/selVehicleListByParam', {
          typeList: ['CC', 'RC'],
          manuId: this.manuId,
        })
        .then((res) => {
          console.log('selShopListBySortDesc==', res);
          if (res) {
            this.mapData.lines = res.map((item) => {
              let fromName = '';
              let toName = '';
              const count = item.num || '0';
              const coords = [[114.971, 44.0227]];
              item.longitude = parseFloat(item.longitude);
              item.latitude = parseFloat(item.latitude);
              if (item.type === 'RC') {
                fromName = item.sourceAreaName.substring(0, item.sourceAreaName.indexOf('/'));
                toName = '张北园区';
                coords.push([item.longitude, item.latitude]);
              } else {
                fromName = '张北园区';
                toName = item.sourceAreaName.substring(0, item.sourceAreaName.indexOf('/'));
                coords.push([item.longitude, item.latitude]);
              }
              return {
                fromName,
                toName,
                coords,
                count,
              };
            });
            console.log(this.mapData);
            this.flag = !this.flag;
          }
        });
    },
    counUnpaidFodderOrderNumByParam() {
      this.$store
        .dispatch('zbData/counUnpaidFodderOrderNumByParam', {
          tagsType: 'SHOP_TAGS',
          tagsCode: 'JPJJR',
          pageNum: 1,
          pageSize: 7,
        })
        .then((res) => {
          console.log('selShopListBySortDesc==', res);
        });
    },
    // 现存品类数据
    countNumGroupByCate() {
      this.$store
        .dispatch('zbData/countNumGroupByCate', {
          manuId: this.manuId,
        })
        .then((res) => {
          console.log('selShopListBySortDesc==', res);
          if (res) {
            this.leftPanel2.data = res.map((item) => {
              return {
                name: item.categoryName,
                value: item.cargoNum,
              };
            });
            this.flag1 = !this.flag1;
          }
        });
    },
    // 进场车辆数目
    countNumByType() {
      this.$store
        .dispatch('zbData/countNumByType', {
          manuId: this.manuId,
        })
        .then((res) => {
          console.log('selShopListBySortDesc==', res);
          if(res) {
            this.entranceInfo = res;
          }
        });
    },
    // 实时交易公告板
    selTradingBulletinBoard() {
      this.$store
        .dispatch('zbData/selTradingBulletinBoard', {
          saleType: 'ORDINARY',
          manuId: this.manuId,
          pageNum: 1,
          pageSize: 20,
        })
        .then((res) => {
          console.log('selShopListBySortDesc==', res);
          if (res && res.list) {
            this.swiperlist = res.list.map((item) => {
              const startIndex = item.orderTime.indexOf('-') + 1;
              const endIndex = item.orderTime.lastIndexOf(':');
              const orderTime = item.orderTime.substring(startIndex, endIndex);
              return {
                categoryName: item.categoryName,
                goodsName: item.goodsName,
                sellPrice: item.sellPrice,
                orderTime,
              };
            });
          }
        });
    },
    // 累计交易额_累计交易数量_今日交易额_今日交易数量
    selTradingData() {
      this.$store
        .dispatch('zbData/selTradingData', {
          categoryAxisLike: '$11$',
          manuId: this.manuId,
          saleType: 'ORDINARY',
        })
        .then((res) => {
          console.log('selShopListBySortDesc==', res);
          if (res) {
            this.transactionInfo = res;
          }
        });
    },
    // 平台总交易额（图表展示）
    selPaidMoneyGroupByCategory() {
      this.progress = false;
      this.$store
        .dispatch('zbData/selPaidMoneyGroupByCategory', {
          categoryAxisLike: '$11$',
          manuId: this.manuId,
        })
        .then((res) => {
          console.log('selShopListBySortDesc==', res);
          if (res) {
            let sum = 0;
            res.forEach((item) => {
              sum += item.paidMoney;
            });
            this.rightPanel1 = res.map((item) => {
              return {
                name: `${item.twoCategoryName}交易`,
                width: (100 * item.paidMoney) / sum,
                text: item.paidMoney,
              };
            });
          }
          this.progress = true;
        });
    },
    // 优质商家
    selShopListBySortDesc() {
      this.$store
        .dispatch('zbData/selShopListBySortDesc', {
          order: 'sort ASC,create_time ASC',
          status: 'TG',
          pageNum: 1,
          pageSize: 7,
        })
        .then((res) => {
          console.log('selShopListBySortDesc==', res);
          if (res && res.list) {
            this.swiperlist2 = res.list.map((item) => {
              let num = '★★★★★';
              if (item.rank === 5) {
                num = '★★★★★';
              } else if (item.rank === 4) {
                num = '★★★★';
              } else if (item.rank === 3) {
                num = '★★★';
              }
              return {
                shopName: item.shopName,
                num: num,
              };
            });
          }
        });
    },
    // 金牌经济人
    selShopTageRankingByParam() {
      this.$store
        .dispatch('zbData/selShopTageRankingByParam', {
          tagsType: 'SHOP_TAGS',
          tagsCode: 'JPJJR',
          pageNum: 1,
          pageSize: 7,
        })
        .then((res) => {
          console.log('selShopTageRankingByParam==', res);
          if (res && res.list) {
            this.swiperlist3 = res.list.map((item) => {
              let num = '★★★★★';
              if (item.rank === 5) {
                num = '★★★★★';
              } else if (item.rank === 4) {
                num = '★★★★';
              } else if (item.rank === 3) {
                num = '★★★';
              }
              return {
                name: item.realName || item.userName,
                num: num,
              };
            });
          }
        });
    },
    imgarrCLick(item) {
      item.show = !item.show;
      if (item.type == 'YQ') {
        this.mapData.garden.forEach((element) => {
          element.show = !element.show;
        });
      } else if (item.type == 'C') {
        this.mapData.grass.forEach((element) => {
          element.show = !element.show;
        });
      } else if (item.type == 'N') {
        this.mapData.cow.forEach((element) => {
          element.show = !element.show;
        });
      } else if (item.type == 'M') {
        this.mapData.horse.forEach((element) => {
          element.show = !element.show;
        });
      } else if (item.type == 'Y') {
        this.mapData.sheep.forEach((element) => {
          element.show = !element.show;
        });
      }
      this.flag = !this.flag;
    },
    datalist() {
      return;
    },
    leftPanel1Click(index) {
      this.leftPanel1active = index;
      this.flag1 = !this.flag1;
      let ars = [];
      let ars2 = [];
      if (index == 0) {
        ars = arr1;
        ars2 = arr2;
      } else if (index == 1) {
        ars = arr3;
        ars2 = arr4;
      } else if (index == 2) {
        ars = arr5;
        ars2 = arr6;
      } else if (index == 3) {
        ars = arr7;
        ars2 = arr8;
      }
      this.leftPanel1.data = ars;
      this.leftPanel1s.data = ars2;
    },
    leftPanel2Click1() {
      this.leftPanel2active1 = !this.leftPanel2active1;
      this.leftPanel2.series[0].show = !this.leftPanel2.series[0].show;
      this.flag2 = !this.flag2;
    },
    leftPanel2Click2() {
      this.leftPanel2active2 = !this.leftPanel2active2;
      this.leftPanel2.series[1].show = !this.leftPanel2.series[1].show;
      this.flag2 = !this.flag2;
    },
    leftPanel3Click1() {
      this.leftPanel3active1 = !this.leftPanel3active1;
      this.leftPanel3.series[0].show = !this.leftPanel3.series[0].show;
      this.flag3 = !this.flag3;
    },
    leftPanel3Click2() {
      this.leftPanel3active2 = !this.leftPanel3active2;
      this.leftPanel3.series[1].show = !this.leftPanel3.series[1].show;
      this.flag3 = !this.flag3;
    },
    leftPanel4Click1() {
      this.leftPanel4active1 = !this.leftPanel4active1;
      this.leftPanel4.series[0].show = !this.leftPanel4.series[0].show;
      this.flag4 = !this.flag4;
    },
    leftPanel4Click2() {
      this.leftPanel4active2 = !this.leftPanel4active2;
      this.leftPanel4.series[1].show = !this.leftPanel4.series[1].show;
      this.flag4 = !this.flag4;
    },
    rightPanel2Click1() {
      this.rightPanel2active1 = !this.rightPanel2active1;
      this.rightPanel2.series[0].show = !this.rightPanel2.series[0].show;
      this.flag5 = !this.flag5;
    },
    rightPanel2Click2() {
      this.rightPanel2active2 = !this.rightPanel2active2;
      this.rightPanel2.series[1].show = !this.rightPanel2.series[1].show;
      this.flag5 = !this.flag5;
    },
    rightPanel2Click3() {
      this.rightPanel2active3 = !this.rightPanel2active3;
      this.rightPanel2.series[2].show = !this.rightPanel2.series[2].show;
      this.flag5 = !this.flag5;
    },
    rightPanel2Click4() {
      this.rightPanel2active4 = !this.rightPanel2active4;
      this.rightPanel2.series[3].show = !this.rightPanel2.series[3].show;
      this.flag5 = !this.flag5;
    },
    rightPanel2Click5() {
      this.rightPanel2active5 = !this.rightPanel2active5;
      this.rightPanel2.series[4].show = !this.rightPanel2.series[4].show;
      this.flag5 = !this.flag5;
    },
  },
};
